import React from 'react'
import { func, string } from 'prop-types'

const MoreFilterButton = props => {
  if (props.title !== 'Filter') {
    return (
      <button
        className="panel-buttons__more"
        onClick={() => props.handleClick('Refine')}
      >
        More filters
      </button>
    )
  }
  return null
}

MoreFilterButton.propTypes = {
  handleClick: func,
  title: string
}

export default MoreFilterButton
